// Imports
import React from 'react';
import styled from 'styled-components/macro';
import helperFunctions from '../../utils/helper-functions';
import { fieldContainerBottomMargin } from './field-container';
import { Label } from './labels';


// Styled components
const Container = styled.fieldset`
	border: 0;
	
	&:not(:last-child) {
		margin-bottom: ${fieldContainerBottomMargin};
	}
	
	&:last-child {
		margin-bottom: 0;
	}
	
	div[class^='field-container']:not(:last-child) {
		margin-bottom: 0.5em;
	}
`;


// Define the accepted props
interface Props extends React.PropsWithChildren {
	label?: string;
	note?: string | React.ReactElement;
}


// Functional component
const MultiCheckboxContainer: React.FC<Props> = ({ children, label, note, ...passThroughProps }) => {
	// Determine the display names of direct children fields
	const displayNames: string[] = [];
	
	helperFunctions.recursivelyIterate(children, (child) => {
		if (!React.isValidElement(child)) {
			return child;
		}
		
		
		// @ts-ignore: displayName does exist
		const { displayName } = child.type;
		
		if (displayName && typeof displayName === 'string') {
			displayNames.push(displayName);
		}
		
		return child;
	});
	
	
	// Throw if an unsupported field was used
	if (displayNames.some((displayName) => displayName !== 'Checkbox')) {
		throw new Error('Only Checkbox fields are supported');
	}
	
	
	// Return JSX
	return (
		<Container {...passThroughProps}>
			{label && (
				<Label as='legend'>
					{label}
					{note && <small>{note}</small>}
				</Label>
			)}
			
			{children}
		</Container>
	);
};

export default MultiCheckboxContainer;
